import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/contexts/ThemeContext";
import { useTranslation } from "react-i18next";

interface Props {
  variant?: "ghost" | "outline";
  className?: string;
}

export const ThemeToggle = ({ variant = "ghost", className }: Props) => {
  const { theme, toggle } = useTheme();
  const { t } = useTranslation();
  const label = theme === "dark" ? t("theme.toLight") : t("theme.toDark");

  return (
    <Button
      type="button"
      variant={variant}
      size="icon"
      onClick={toggle}
      aria-label={label}
      title={label}
      className={`relative ${className ?? ""}`}
    >
      <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
    </Button>
  );
};
